import { GridsterConfig } from 'angular-gridster2';
import { IWidgetCategory, WidgetTypes } from './interfaces';
import { environment } from '@environments/environment';
import { EnvironmentNameEnum } from '@environments/environment.enum';
import { TranslateService } from '@ngx-translate/core';
import { getTransactionsDataGridConfig } from '@app/admin-station/work-center/transactions/components/transactions-view/transactionsDataGridConfig';

export const userWidgetsKey = environment.name == EnvironmentNameEnum.LOCAL ? 'user:widgets:local' : 'user:widgets';
export const autoRefreshKey = 'user:auto:refresh';

export const autoRefreshIntervalTime = 60000;

export const buildStockLevels = (stockLevelTypes) =>
  stockLevelTypes?.map(({ name, value }) => {
    if (value.includes('OrderPoint')) return { name: 'Order Point', value: 'Order Point' };
    return { name, value };
  }) || [];

export const widgetOptions: GridsterConfig = {
  gridType: 'scrollVertical',
  compactType: 'none',
  margin: 10,
  outerMargin: true,
  enableBoundaryControl: true,
  draggable: {
    enabled: true,
    dragHandleClass: 'drag-handle',
    ignoreContent: true,
    delayStart: 100,
  },
  resizable: {
    enabled: true,
    delayStart: 100,
  },
  pushItems: true,
  displayGrid: 'onDrag&Resize',
  minCols: 4,
  maxCols: 4,
  minRows: 4,
  mobileBreakpoint: 0,
};

export const draggableImageOptions: GridsterConfig = {
  gridType: 'scrollHorizontal',
  compactType: 'compactLeft&Up',
  margin: 10,
  outerMargin: true,
  enableBoundaryControl: false,
  draggable: {
    enabled: true,
    dragHandleClass: 'drag-handle',
    ignoreContent: true,
    delayStart: 100,
  },
  resizable: {
    enabled: false,
  },
  pushItems: true,
  displayGrid: 'onDrag&Resize',
  maxCols: 50,
  minCols: 2,
  maxRows: 1,
  minRows: 1,
  fixedColWidth: 80,
  fixedRowHeight: 80,
  mobileBreakpoint: 0,
};

export const widgetSizes = {
  small: {
    rows: 2,
    cols: 1,
  },
  medium: {
    rows: 2,
    cols: 2,
  },
  large: {
    rows: 2,
    cols: 3,
  },
  extraLarge: {
    rows: 2,
    cols: 4,
  },
};

const defaultPosition = {
  x: 0,
  y: 0,
};

// Map the configs by its name and load it + extra plain modifications
export const getGridConfigMap = (translateService: TranslateService) => ({
  transactionsDataGridConfig: getTransactionsDataGridConfig(translateService),
});

export const widgetCategories: IWidgetCategory[] = [
  {
    id: 'widgets.crib-and-bins',
    widgets: [
      {
        title: 'widgets.cribs-overview',
        dataCy: 'cribs-overview-preview',
        type: WidgetTypes.DATAGRID,
        config: 'cribsDataGridConfig',
        path: '#/cribs-and-bins',
        ...widgetSizes.medium,
        ...defaultPosition,
      },
      {
        title: 'widgets.bins-overview',
        dataCy: 'bins-overview-preview',
        type: WidgetTypes.DATAGRID,
        config: 'binsDataGridConfig',
        path: '#/cribs-and-bins',
        ...widgetSizes.medium,
        ...defaultPosition,
      },
      {
        title: 'widgets.access-log',
        dataCy: 'access-log-preview',
        type: WidgetTypes.DATAGRID,
        config: 'accessLogDataGridConfig',
        path: '#/reports',
        ...widgetSizes.medium,
        ...defaultPosition,
      },
    ],
  },
  {
    id: 'widgets.purchasing',
    widgets: [
      {
        title: 'widgets.replenishment',
        dataCy: 'replenishment-preview',
        type: WidgetTypes.DATAGRID,
        config: 'replenishmentsDataGridConfig',
        path: '#/replenishments',
        ...widgetSizes.medium,
        ...defaultPosition,
      },
      {
        title: 'widgets.purchase-orders',
        dataCy: 'purchase-order-preview',
        type: WidgetTypes.DATAGRID,
        config: 'PurchaseOrdersDataGridConfig',
        path: '#/purchase-orders',
        ...widgetSizes.medium,
        ...defaultPosition,
      },
    ],
  },
  {
    id: 'widgets.reports',
    widgets: [
      {
        title: 'widgets.transaction-overview',
        dataCy: 'transaction-preview',
        type: WidgetTypes.DATAGRID,
        config: 'transactionsDataGridConfig',
        path: '#/reports',
        ...widgetSizes.medium,
        ...defaultPosition,
      },
    ],
  },
  {
    id: 'widgets.miscellaneous',
    widgets: [
      {
        title: 'widgets.notification-panel',
        dataCy: 'notification-preview',
        path: '#/notifications-center',
        type: WidgetTypes.NOTIFICATIONS,
        ...widgetSizes.medium,
        ...defaultPosition,
      },
    ],
  },
];
